<template>
  <component
    :is="tag"
    :class="
      `title${(underlined && ' underlined') || ''}
        ${theme == 'primary' ? ' title__primary' : ''}
        ${theme == 'normal' ? ' title__normal' : ''}`
    "
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "Title",
  props: {
    tag: {
      type: String,
      default: "h",
      validator(value) {
        return ["h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
      }
    },
    underlined: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: "primary"
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.title {
  &__primary {
    color: variables.$primary-color;
  }
  &__normal {
    color: variables.$text-color;
  }
  &.underlined {
    position: relative;
    &::after {
      display: block;
      content: "";
      width: 50px;
      border-bottom: 3px solid currentColor;
      padding-top: 0.5em;
    }
  }
}
h3 {
  text-transform: uppercase;
}
h2 {
  font-size: variables.$fs-title-sm;
  letter-spacing: 0.05rem;
}
</style>
